/**
 * Gli indirizzi delle due informative, quelli a cui le modali e le pagine rimandano. Sono rotte della
 * radice (`app.routes.ts`), fuori dalla cornice autenticata: chi le apre non deve avere una sessione.
 */
export const PRIVACY_POLICY_PATH = '/privacy';
export const COOKIE_POLICY_PATH = '/cookie';

/** Le pagine su cui l'avviso sui cookie non si mostra: sono gia' l'informativa che l'avviso rimanda. */
export const LEGAL_PAGE_PATHS: readonly string[] = [PRIVACY_POLICY_PATH, COOKIE_POLICY_PATH];
